"use strict";
var core_1 = require('@angular/core');
var SoundBlip = (function () {
    function SoundBlip() {
    }
    __decorate([
        core_1.Input(), 
        __metadata('design:type', Object)
    ], SoundBlip.prototype, "sound", void 0);
    SoundBlip = __decorate([
        core_1.Component({
            selector: 'sound-blip',
            template: "\n    <div class=\"note\"></div>\n  ",
            pipes: [],
            directives: [],
            encapsulation: core_1.ViewEncapsulation.Emulated,
            styles: ["\n    .note {\n      height: 12px;\n      width: 16px;\n      background: red;\n      border-radius: 6px;\n    }\n    ",
            ],
            changeDetection: core_1.ChangeDetectionStrategy.OnPush,
        }), 
        __metadata('design:paramtypes', [])
    ], SoundBlip);
    return SoundBlip;
}());
exports.SoundBlip = SoundBlip;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJpbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEscUJBT08sZUFBZSxDQUFDLENBQUE7QUFxQnZCO0lBR0U7SUFBZSxDQUFDO0lBRmhCO1FBQUMsWUFBSyxFQUFFOzs0Q0FBQTtJQXBCVjtRQUFDLGdCQUFTLENBQUM7WUFDVCxRQUFRLEVBQUUsWUFBWTtZQUN0QixRQUFRLEVBQUUsc0NBRVQ7WUFDRCxLQUFLLEVBQUUsRUFBRTtZQUNULFVBQVUsRUFBRSxFQUFFO1lBQ2QsYUFBYSxFQUFFLHdCQUFpQixDQUFDLFFBQVE7WUFDekMsTUFBTSxFQUFFLENBQUMsd0hBT047YUFDRjtZQUNELGVBQWUsRUFBRSw4QkFBdUIsQ0FBQyxNQUFNO1NBQ2hELENBQUM7O2lCQUFBO0lBTUYsZ0JBQUM7QUFBRCxDQUFDLEFBTEQsSUFLQztBQUxZLGlCQUFTLFlBS3JCLENBQUE7QUFBQSxDQUFDIn0=


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/sequencer/sound-blip/index.ts
 ** module id = 428
 ** module chunks = 1
 **/